import { format } from 'date-fns';
import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Paper,
  Divider,
} from '@mui/material';
import {
  Edit,
  Delete,
  ContentCopy,
  BarChart,
} from '@mui/icons-material';

const STATUS_COLOR = {
  draft: 'default',
  active: 'primary',
  published: 'success',
  closed: 'error',
};

const SeasonMobileList = ({
  seasons,
  canCreate,
  canUpdate,
  canDelete,
  onEdit,
  onDelete,
  onDuplicate,
  onStats,
}) => (
  <Box display="flex" flexDirection="column" gap={2}>
    {seasons.map((row) => (
      <Paper 
        key={row._id} 
        variant="outlined" 
        sx={{ p: 2, borderRadius: 1 }}
      >
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="flex-start" 
          gap={1}
        >
          <Box 
            flex={1} 
            display="flex" 
            flexDirection="column"
            minWidth={0} 
            gap={1} 
          >
            <Box 
              display="flex" 
              flexWrap="wrap"
              alignItems="center" 
              gap={1} 
            >
              <Typography 
                sx={{ 
                  fontFamily: 'monospace', 
                  fontWeight: 600, 
                  fontSize: '0.9rem',
                }}
              >
                {row.seasonCode}
              </Typography>
              <Chip
                label={row.iataCode === 'S' ? 'Summer' : 'Winter'}
                size="small"
                color={row.iataCode === 'S' ? 'warning' : 'info'}
                variant="outlined"
              />
              <Chip
                label={row.status}
                size="small"
                color={STATUS_COLOR[row.status] || 'default'}
              />
            </Box>
            <Typography variant="body2" sx={{ mt: 0.25 }} noWrap>
              {row.seasonName}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
              {row.startDate ? format(new Date(row.startDate), 'dd MMM yy') : '-'}
              {' → '}
              {row.endDate   ? format(new Date(row.endDate),   'dd MMM yy') : '-'}
            </Typography>
          </Box>

          <Box display="flex" gap={1}>
            <Tooltip title="Stats">
              <IconButton size="small" onClick={() => onStats(row)}>
                <BarChart fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Duplicate">
              <IconButton size="small" disabled={!canCreate} onClick={() => onDuplicate(row)}>
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton size="small" disabled={!canUpdate} onClick={() => onEdit(row)}>
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton size="small" disabled={!canDelete} onClick={() => onDelete(row._id)} sx={{ color: 'error.main' }}>
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {row.baseAirline && (
          <>
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" color="text.secondary">
              Airline: {row.baseAirline}
            </Typography>
          </>
        )}
      </Paper>
    ))}
  </Box>
);

export default SeasonMobileList;
